export const inputStyles = {
  baseStyle: {},
  sizes: {},
  variants: {},
}
